<script>
/**
 * Type         : Biz component
 * Title        : 콘솔검색 컴포넌트
 * Description  : 콘솔 검색을 위한 컴포넌트
 * 
 ************ 검색조건 ************
 * 
 * M/BL No
 * 운항편명
 * 콘솔상태
 * 
 * 출발예정일
 * 도착예정일
 * 
 */

export default {
  name: "Biz-consol-lookup-form",
  emits:[
    'lookup-opt-sync',
  ],
  components: {
  },
  data() {
    return {
      description   : {
        title : '콘솔검색'
      },
      calendarTarget : [
        { value: 'etd', label: '출발예상일' },
        { value: 'eta', label: '도착예정일' },
      ],


      mblNo             : "", // mblNo
      orderNum          : "", // 운항편명
      statusCode        : [], // 오더 상태 코드 목록

      selectedCalendarTarget : 'etd', // 선택된 캘린더 타겟

      startDate     : "",
      endDate       : "",
      datepicker    : {
        from  : "",
        to    : ""
      },
      proxyDate     : {
        from  : "",
        to    : ""
      },
      startDatePopup : false,
      endDatePopup   : false,
    }
  },

  methods:{

    syncDateRange () {
      if (this.startDate && this.endDate && this.startDate > this.endDate) {
        const temp = this.startDate
        this.startDate = this.endDate
        this.endDate = temp
      }

      this.proxyDate = {
        from: this.startDate,
        to: this.endDate
      }
      this.datepicker = {
        from: this.startDate,
        to: this.endDate
      }
      this.lookupOptSync()
    },

    saveStartDate () {
      this.startDatePopup = false
      this.syncDateRange()
    },

    saveEndDate () {
      this.endDatePopup = false
      this.syncDateRange()
    },

    getDateMonthsAgo(months) {
      const date = new Date()
      date.setMonth(date.getMonth() - months)
      return this.formatDate(date)
    },

    formatDate(date) {
      const year = date.getFullYear()
      const month = this.lPad(date.getMonth() + 1, 2)
      const day = this.lPad(date.getDate(), 2)
      return `${year}-${month}-${day}`
    },

    setQuickRange(months) {
      this.startDate = this.getDateMonthsAgo(months)
      this.endDate = this.getToday()
      this.syncDateRange()
    },


    /**
     * Title        : 검색조건 동기화
     * Status       : Actived
     * Description  : 화물 검색을 위한 조건을 parents에 전달한다.
     */
    lookupOptSync(){
      this.$log.debug("[ Consol lookup form / lookupOptSync ]")

      // 검색조건을 동기화한다.
      let opt = {
        mblNo             : this.mblNo.replaceAll(' ', ''),
        freightCode       : this.orderNum.replaceAll(' ', ''),
        statusCode        : this.statusCode,
        
        selectedCalendarTarget    : this.selectedCalendarTarget,
        proxyDate         : this.proxyDate
      }

      this.$emit('lookup-opt-sync', opt)
    },


    /**
     * Title        : 숫자 앞에 0을 채워서 길이를 맞춘다.
     * Status       : Actived
     * Description  : 숫자 앞에 0을 채워서 길이를 맞춘다.
     * @param {Number} num - 숫자
     * @param {Number} length - 길이
     */
    lPad(num, length) {
      this.$log.debug("[ Parcel lookup form / lPad ] num = ", num, ", length = ", length)

      // 숫자를 문자열로 변환하고, 길이가 length보다 작으면 앞에 0을 채운다.
      return String(num).padStart(length, '0')
    },

    /**
     * Title        : 캘린더 default 설정
     * Status       : Actived
     * Description  : 오늘 날짜 획득
     */
    getToday(){
      let today = new Date().toDateString()

      let newToday = new Date(today)

      let year  = newToday.getFullYear()    // 년
      let month = newToday.getMonth() + 1   // 월
      let day   = newToday.getDate()        // 일
      
      let result = year + "-" + this.lPad(month, 2) + "-" + this.lPad(day, 2)

      this.$log.debug("[ Parcel lookup form / getToday ] = ", result)

      return result
    },
    
    /**
     * Title        : 캘린더 default 설정
     * Status       : Actived
     * Description  : 일주일 이후 날짜 획득
     */
    getAWeekLater(){
      let today = new Date().toDateString()
      
      let newToday = new Date(today)
      
      let year  = newToday.getFullYear()    // 년
      let month = newToday.getMonth() + 1   // 월
      let day   = newToday.getDate()        // 일

      let aWeekLater = new Date(new Date().setDate(day + 7))

      let newAWeekLater = new Date(aWeekLater)

      year  = newAWeekLater.getFullYear() // 년
      month = newAWeekLater.getMonth() + 1  // 월
      day   = newAWeekLater.getDate()      // 일

      let result = year + "-" + this.lPad(month, 2) + "-" + this.lPad(day, 2)

      this.$log.debug("[ Parcel lookup form / getAWeekLater ] = ", result)

      return result
    },

    /**
     * Title        : 캘린더 default 설정
     * Status       : Actived
     * Description  : 일주일전 날짜 획득
     */
    getAWeekAgo(){
      let today = new Date().toDateString()

      let newToday = new Date(today)

      let year  = newToday.getFullYear()    // 년
      let month = newToday.getMonth() + 1   // 월
      let day   = newToday.getDate()        // 일

      let aWeekAgo = new Date(new Date().setDate(day - 7))

      let newAWeekAgo = new Date(aWeekAgo)

      year  = newAWeekAgo.getFullYear() // 년
      month = newAWeekAgo.getMonth() + 1  // 월
      day   = newAWeekAgo.getDate()      // 일

      let result = year + "-" + this.lPad(month, 2) + "-" + this.lPad(day, 2)

      this.$log.debug("[ Parcel lookup form / getAWeekAgo ] = ", result)

      return result
    },

    /**
     * Title        : 캘린더 default 설정
     * Status       : Actived
     * Description  : 캘린더의 일자를 기본설정으로 돌린다.
     */
    async initCalendar(){
      this.$log.debug("[ Parcel lookup form / initCalendar ]")

      const aWeekAgo  = this.getAWeekAgo()
      const aWeekLater     = this.getAWeekLater()
      
      this.startDate = aWeekAgo
      this.endDate = aWeekLater

      this.datepicker  = { 
        from  : aWeekAgo,
        to    : aWeekLater
      }

      this.proxyDate   = { 
        from  : aWeekAgo,
        to    : aWeekLater
      }
      
      this.lookupOptSync()
    },

    /**
     * Title        : 최초설정
     * Status       : Actived
     * Description  : 검색 조건 값을 default 한다.
     */
    async init(){
      this.$log.debug("[ Parcel lookup form / init ]")

      await this.initCalendar()
      
      this.$emit('lookup-consol')
    }
  },

  beforeMount(){
    // 오더상태 코드목록
    this.$getCodeList('CONSTT')
  },
  
  mounted(){
    this.init()
  }
}
</script>

<template>
  <div class="row q-col-gutter-lg">
      <div class="col-12 col-md-6">
        
      <q-input
        v-model="mblNo" 
        @update:model-value="lookupOptSync" 
        label="M/BL No." />
    
      <q-input
        v-model="orderNum" 
        @update:model-value="lookupOptSync" 
        label="운항편명" />

    </div>


    <!-- 

      검색 조건 오른쪽

    -->
    <div class="col-12 col-md-6">
      <!-- 콘솔 상태 체크박스 -->
      <q-radio
        v-for="(item, index) in calendarTarget" :key="index"
        v-model="selectedCalendarTarget"
        @update:modelValue="lookupOptSync"
        :val="item.value"
        :label="item.label" 
        color="teal" />

      <div class="range-picker">
        <div class="row q-col-gutter-sm items-start">
          <div class="col-12 col-sm-6">
            <q-input
              v-model="startDate"
              label="시작 날짜"
              readonly>
              <template v-slot:append>
                <q-btn flat round icon="event" color="primary">
                  <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                    <q-date v-model="startDate" mask="YYYY-MM-DD">
                      <div class="row items-center justify-end q-gutter-sm">
                        <q-btn label="Cancel" color="primary" flat v-close-popup />
                        <q-btn label="OK" color="primary" flat @click="saveStartDate" v-close-popup />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-btn>
              </template>
            </q-input>
          </div>

          <div class="col-12 col-sm-6">
            <q-input
              v-model="endDate"
              label="끝 날짜"
              readonly>
              <template v-slot:append>
                <q-btn flat round icon="event" color="primary">
                  <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                    <q-date v-model="endDate" mask="YYYY-MM-DD">
                      <div class="row items-center justify-end q-gutter-sm">
                        <q-btn label="Cancel" color="primary" flat v-close-popup />
                        <q-btn label="OK" color="primary" flat @click="saveEndDate" v-close-popup />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-btn>
              </template>
            </q-input>
          </div>
        </div>

        <div class="row q-col-gutter-sm q-mt-sm quick-range-buttons">
          <div class="col-auto">
            <q-btn outline color="primary" label="최근 1달" @click="setQuickRange(1)" />
          </div>
          <div class="col-auto">
            <q-btn outline color="primary" label="최근 3달" @click="setQuickRange(3)" />
          </div>
          <div class="col-auto">
            <q-btn outline color="primary" label="최근 6개월" @click="setQuickRange(6)" />
          </div>
          <div class="col-auto">
            <q-btn outline color="primary" label="최근 1년" @click="setQuickRange(12)" />
          </div>
        </div>

        <div class="text-caption text-grey q-mt-sm">
          {{ datepicker.from }} ~ {{ datepicker.to }}
        </div>
      </div>

      <!-- 콘솔 상태 체크박스 -->
      <q-checkbox
        v-for="(item, index) in this.$store.getters.getConsolStatusList" :key="index"
        v-model="statusCode"
        @update:modelValue="lookupOptSync"
        :val="item.value"
        :label="item.label" 
        color="teal" />

    </div>
  </div>
  
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.range-picker {
  font-size: 20px;
  font-weight: 400;

  margin-bottom: 10px;
}

.quick-range-buttons {
  justify-content: flex-end;
}

</style>
